
<div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-12">
        <h2>Alta Personal
        <configTools 
          [rowsExport]="rowsExport"
          [Title]="tituloTabla"
          [bNew]="false"
          (ImportChange)="import($event)"
          ></configTools>
        </h2>
    </div>
</div>
<div class="wrapper wrapper-content animated fadeInRight">
    <div class="row">
        <div class="col-lg-12">
            <div class="header">
                <div class="ibox-content">
                    <mat-error *ngIf="altaInvalida" class="altaInvalida">{{MensajeError}}</mat-error>
                    
                        <mat-vertical-stepper [linear]="isLinear" #stepper>
                        <mat-step [stepControl]="firstFormGroup" errorMessage="Datos Erróneos">
                            <form class="form" [formGroup]="firstFormGroup">
                                <ng-template matStepLabel>Datos de Organización</ng-template>
                                                
                                <div class="row panel panel-warning">
                                    <div class="col-lg">
                                        <label class="col-form-label font-bold" for="desde">Desde</label>
                                        <div class="col-lg-8" >
                                            <p-calendar appendTo="body" selectOtherMonths="true"  formControlName="desde" required dateFormat="dd/mm/yy" inputId="desde" ngDefaultControl></p-calendar>
                                            <div *ngIf="f1.desde.errors?.required && (f1.desde?.dirty || f1.desde?.touched || submitted || saleform1)" class="text-danger">La Fecha es Requerida</div>
                                            <mat-error *ngIf="f1.desde.errors?.anteriorRetroactividad && (f1.desde?.dirty || f1.desde?.touched || submitted || saleform1)" class="text-danger">
                                                No puede ser anterior al límite de retroactividad {{grupoLiq.periodoRetroactividadNavigation.fechaDd | date:'dd/MM/yyyy'}}
                                            </mat-error>
                                        </div>
                                    </div>
                                    <div class="col-lg">
                                        <label class="col-form-label font-bold" for="hasta">Hasta</label>
                                        <div class="col-lg-8" >
                                            <p-calendar appendTo="body" selectOtherMonths="true"  formControlName="hasta" required dateFormat="dd/mm/yy" inputId="hasta" ngDefaultControl></p-calendar>
                                            <div *ngIf="f1.hasta.errors?.required && (f1.hasta?.dirty || f1.hasta?.touched || submitted || saleform1)"  class="text-danger">La Fecha es Requerida</div>
                                            <mat-error  class="text-danger" *ngIf="f1.hasta.errors?.fecHastaMenor && (f1.hasta?.dirty || f1.hasta?.touched || submitted || saleform1)">
                                                La Fecha no puede ser menor que la Fecha Desde
                                            </mat-error>
                                        </div>
                                    </div>
                                </div>
                                                    

                                <div class="row">
                                    <div class="col-lg">
                                        <label class="col-form-label font-bold">Sociedad</label>
                                        <comboTools
                                            [list]=sociedadesList
                                            [formParent]="firstFormGroup"
                                            selected='sociedad'
                                            [isEditing]=disabledEditing
                                            filter="descripcion"
                                            (SelectedChange)="onChangeSociedad($event)"
                                        ></comboTools>
                                        <mat-error  class="text-danger"*ngIf="f1.sociedad.errors?.required && (f1.sociedad?.dirty || f1.sociedad?.touched || submitted || saleform1)">
                                            La Sociedad es Requerida
                                        </mat-error>
                                    </div>
                                </div>
                                                    
                                <div class="row">
                                    <div class="col-lg">
                                        <label class="col-form-label font-bold">Unidad Organizativa</label>
                                        <comboTools
                                            [list]=UnidadesOrganizativasList
                                            selected='unidadOrganizativa'
                                            [isEditing]=disabledEditing
                                            filter="descripcion"
                                            [formParent]="firstFormGroup"
                                        ></comboTools>
                                        <mat-error  class="text-danger"*ngIf="f1.unidadOrganizativa.errors?.required && (f1.unidadOrganizativa?.dirty || f1.unidadOrganizativa?.touched || submitted || saleform1)">
                                            La Unidad Organizativa es requerida
                                        </mat-error>
                                    </div>
                                    <div class="col-lg">
                                        <label class="col-form-label font-bold">Posición</label>
                                        <comboTools
                                            [list]=PosicionesList
                                            selected='posicion'
                                            [isEditing]=disabledEditing
                                            filter="descripcion"
                                            [formParent]="firstFormGroup"
                                        ></comboTools>
                                        <mat-error  class="text-danger"*ngIf="f1.posicion.errors?.required && (f1.posicion?.dirty || f1.posicion?.touched || submitted || saleform1)">
                                            La Posición es requerida
                                        </mat-error>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-lg">
                                        <label class="col-form-label font-bold">Sede</label>
                                        <comboTools
                                            [list]=sedesList
                                            [formParent]="firstFormGroup"
                                            selected='sede'
                                            [isEditing]=disabledEditing
                                            filter="descripcion"
                                            (SelectedChange)="onChangeSede($event)"
                                        ></comboTools>
                                        <mat-error  class="text-danger"*ngIf="f1.sede.errors?.required && (f1.sede?.dirty || f1.sede?.touched || submitted || saleform1)">
                                            La Sede es requerida
                                        </mat-error>
                                    </div>                    
                                    <div class="col-lg">
                                        <label class="col-form-label font-bold">Subsede</label>
                                        <comboTools
                                            [list]=SubSedesList
                                            [formParent]="firstFormGroup"
                                            selected='subSede'
                                            [isEditing]=disabledEditing
                                            filter="descripcion"
                                        ></comboTools>
                                        <mat-error  class="text-danger"*ngIf="f1.subSede.errors?.required && (f1.subSede?.dirty || f1.subSede?.touched || submitted || saleform1)">
                                            La Subsede es requerida
                                        </mat-error>
                                    </div>                    
                                </div>

                                <div>
                                    <br>
                                    <button matStepperNext class="btn btn-secondary btn-lg" type="button" (click)="sale1()">Siguiente</button>
                                </div>
                            </form>
                        </mat-step>
                        
                        <mat-step [stepControl]="secondFormGroup" errorMessage="Datos Erróneos">
                            <form class="form" [formGroup]="secondFormGroup">
                                <ng-template matStepLabel>Datos de Liquidación</ng-template>
                                <div class="row">
                                    <div class="col-lg">
                                        <label class="col-form-label font-bold">Grupo Liquidación</label>
                                        <comboTools
                                            [list]=GruposLiquidacionList
                                            selected='grupoLiquidacion'
                                            [isEditing]=disabledEditing
                                            filter="descripcion"
                                            [formParent]="secondFormGroup"
                                            ph= "Grupo Liquidación"
                                        ></comboTools>
                                        <mat-error  class="text-danger" *ngIf="f2.grupoLiquidacion.errors?.required && (f2.grupoLiquidacion?.dirty || f2.grupoLiquidacion?.touched || submitted || saleform2)">
                                            El Grupo Liquidación es Requerido
                                        </mat-error>
                                        <mat-error *ngIf="grupoActual && (f2.grupoLiquidacion?.dirty || f2.grupoLiquidacion?.touched || submitted || saleform2)" class="text-danger">
                                            El Grupo Liquidación no tiene definido un Período Actual
                                        </mat-error>
                                        <mat-error *ngIf="grupoRetroactividad && (f2.grupoLiquidacion?.dirty || f2.grupoLiquidacion?.touched || submitted || saleform2)" class="text-danger">
                                            El Grupo Liquidación no tiene definido un Período Retroactividad
                                        </mat-error>
                                    </div>
                                    <div class="col-lg">
                                        <label class="col-form-label font-bold">Grupo Personal</label>
                                        <comboTools
                                            [list]=GruposList
                                            selected='grupoPersonal'
                                            [isEditing]=disabledEditing
                                            filter="descripcion"
                                            [formParent]="secondFormGroup"
                                            (SelectedChange)="onChangeGrupo($event)"
                                        ></comboTools>
                                        <mat-error  class="text-danger" *ngIf="f2.grupoPersonal.errors?.required && (f2.grupoPersonal?.dirty || f2.grupoPersonal?.touched || submitted || saleform2)">
                                            El Grupo Personal es Requerido
                                        </mat-error>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-lg">
                                        <label class="col-form-label font-bold">SubGrupo Personal</label>
                                        <comboTools
                                            [list]=SubGruposList
                                            selected='subGrupo'
                                            [isEditing]=disabledEditing
                                            filter="descripcion"
                                            [formParent]="secondFormGroup"
                                        ></comboTools>
                                        <mat-error  class="text-danger" *ngIf="f2.subGrupo.errors?.required && (f2.subGrupo?.dirty || f2.subGrupo?.touched || submitted || saleform2)">
                                            El SubGrupo Personal es Requerido
                                        </mat-error>
                                    </div>
                                </div>
                                <div>
                                    <br>
                                    <button matStepperPrevious class="btn btn-secondary btn-lg" type="button" (click)="sale2()">Anterior</button> 
                                    <button matStepperNext class="btn btn-secondary btn-lg" type="button" (click)="sale2()">Siguiente</button>
                                </div>
                            </form>
                        </mat-step>
                        
                        <mat-step [stepControl]="thirdFormGroup" errorMessage="Datos Erróneos">
                            <form class="form" [formGroup]="thirdFormGroup">
                                <ng-template matStepLabel>Datos Personales</ng-template>
                                <!--  <mat-error  class="text-danger"*ngIf="personalInvalido" class="personalInvalido">{{MensajeError}}</mat-error> -->
                                <div class="row" hidden="true">
                                    <input formControlName="id" name ="id" type="text" class="form-control" />
                                </div>
                                    
                                <div class="row">
                                    <div class="col-lg">
                                        <label class=" col-form-label font-bold">Legajo</label>
                                        <input formControlName="legajo" maxlength="8" name ="selectedLegajo" type="text" class="form-control"  [ngClass]="{ 'is-invalid': f3.legajo.errors && (f3.legajo?.dirty || f3.legajo?.touched || submitted || saleform3)}"/>
                                        <mat-error  class="text-danger"*ngIf="f3.legajo.errors?.required && (f3.legajo?.dirty || f3.legajo?.touched || submitted || saleform3)">
                                            El Legajo es Requerido
                                        </mat-error> 
                                    </div>
                                    <div class="col-lg">
                                        <label class=" col-form-label font-bold">ID Fiscal</label>
                                        <input formControlName="IDfiscal" name ="selectedIdFiscal" type="text" class="form-control"  [ngClass]="{ 'is-invalid': f3.IDfiscal.errors && (f3.IDfiscal?.dirty || f3.IDfiscal?.touched || submitted || saleform3)}" />
                                        <mat-error  class="text-danger"*ngIf="f3.IDfiscal.errors?.required && (f3.IDfiscal?.dirty || f3.IDfiscal?.touched || submitted || saleform3) ">
                                            El ID Fiscal es Requerido
                                        </mat-error>
                                    </div>
                                    <div class="col-lg">
                                        <label class=" col-form-label font-bold">Fecha de Nacimiento</label>
                                        <p-calendar appendTo="body" selectOtherMonths="true"  formControlName="fecNacimiento" required dateFormat="dd/mm/yy" inputId="fecNacimiento" ngDefaultControl></p-calendar>
                                        <mat-error  class="text-danger" *ngIf="f3.fecNacimiento.errors?.required && (f3.fecNacimiento?.dirty || f3.fecNacimiento?.touched || submitted || saleform3)">
                                            La Fecha de Nacimiento es Requerida
                                        </mat-error>
                                        <mat-error  class="text-danger" *ngIf="f3.fecNacimiento.errors?.isYounger && (f3.fecNacimiento?.dirty || f3.fecNacimiento?.touched || submitted || saleform3)">
                                            El Empleado es Menor de Edad
                                        </mat-error>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-lg">
                                        <label class=" col-form-label font-bold">Nombre</label>
                                        <input formControlName="nombre" name ="selectedNombre" type="text" class="form-control"  [ngClass]="{ 'is-invalid': f3.nombre.errors && (f3.nombre?.dirty || f3.nombre?.touched || submitted || saleform3)}"/>
                                        <mat-error  class="text-danger"*ngIf="f3.nombre.errors?.required && (f3.nombre?.dirty || f3.nombre?.touched || submitted || saleform3)">
                                            El Nombre es Requerido
                                        </mat-error>
                                    </div>
                                    <div class="col-lg">
                                        <label class=" col-form-label font-bold">Apellido</label>
                                        <input formControlName="apellido" name ="selectedApellido" type="text" class="form-control"  [ngClass]="{ 'is-invalid': f3.apellido.errors && (f3.apellido?.dirty || f3.apellido?.touched || submitted || saleform3)}"/>
                                        <mat-error  class="text-danger"*ngIf="f3.apellido.errors?.required && (f3.apellido?.dirty || f3.apellido?.touched || submitted || saleform3)">
                                            El Apellido es Requerido
                                        </mat-error>
                                    </div>
                                    <div class="col-lg">
                                        <label class=" col-form-label font-bold">Segundo Apellido</label>
                                        <input formControlName="segundoApellido" name ="selectedSApellido" type="text" class="form-control" [ngClass]="{ 'is-invalid': f3.segundoApellido.errors && (f3.segundoApellido?.dirty || f3.segundoApellido?.touched || submitted || saleform3)}" />                        
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-lg">
                                        <label class=" col-form-label font-bold">Nacionalidad</label>
                                        <comboTools
                                            [list]=paisesList
                                            selected='nacionalidad'
                                            [isEditing]=disabledEditing
                                            filter="descripcion"
                                            [formParent]="thirdFormGroup"
                                        ></comboTools>
                                        <mat-error  class="text-danger" *ngIf="f3.nacionalidad.errors?.required && (f3.nacionalidad?.dirty || f3.nacionalidad?.touched || submitted || saleform3)">
                                            La Nacionalidad es Requerida
                                        </mat-error>
                                    </div>
                                    <div class="col-lg">
                                        <label class=" col-form-label font-bold">Idioma</label>
                                        <comboTools
                                            [list]=idiomasList
                                            selected='idioma'
                                            [isEditing]=disabledEditing
                                            filter="descripcion"
                                            [formParent]="thirdFormGroup"
                                        ></comboTools>
                                        <mat-error  class="text-danger" *ngIf="f3.idioma.errors?.required && (f3.idioma?.dirty || f3.idioma?.touched || submitted || saleform3)">
                                            El Idioma es Requerido
                                        </mat-error>
                                    </div>
                                    <div class="col-lg">
                                        <label class=" col-form-label font-bold">Estado Civil</label>
                                        <comboTools
                                            [list]=estadoCivilList
                                            selected='estadoCivil'
                                            [isEditing]=disabledEditing
                                            filter="descripcion"
                                            [formParent]="thirdFormGroup"
                                        ></comboTools>
                                        <mat-error  class="text-danger" *ngIf="f3.estadoCivil.errors?.required && (f3.estadoCivil?.dirty || f3.estadoCivil?.touched || submitted || saleform3)">
                                            El Estado Civil es Requerido
                                        </mat-error>
                                    </div>                                
                                </div>
                                <div class="row">
                                    <div class="col-lg">
                                        <label class=" col-form-label font-bold">Tratamiento</label>
                                        <comboTools
                                            [list]=tratamientosList
                                            selected='tratamiento'
                                            [isEditing]=disabledEditing
                                            filter="descripcion"
                                            soloDescri=true
                                            [formParent]="thirdFormGroup"
                                        ></comboTools>
                                        <mat-error  class="text-danger" *ngIf="f3.tratamiento.errors?.required && (f3.tratamiento?.dirty || f3.tratamiento?.touched || submitted || saleform3)">
                                            El Tratamiento es Requerido
                                        </mat-error>
                                    </div>
                                    
                                    <div class="col-lg">
                                        <label class=" col-form-label font-bold">Sexo</label>
                                        <comboTools
                                            [list]=sexosList
                                            [formParent]="thirdFormGroup"
                                            selected='sexo'
                                            [isEditing]=disabledEditing
                                            filter="descripcion"
                                        ></comboTools>
                                        <mat-error  class="text-danger" *ngIf="f3.sexo.errors?.required && (f3.sexo?.dirty || f3.sexo?.touched || submitted || saleform3)">
                                            El Sexo es Requerido
                                        </mat-error>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-lg">
                                        <label class=" col-form-label font-bold">Email</label>
                                        <input formControlName="email" name ="selectedMail" type="text" class="form-control" [ngClass]="{ 'is-invalid': f3.email.errors && (f3.email?.dirty || f3.email?.touched || submitted || saleform3)}" />
                                        <mat-error  class="text-danger" *ngIf="f3.email.errors?.required && (f3.email?.dirty || f3.email?.touched || submitted || saleform3)">
                                            El E-Mail es Requerido
                                        </mat-error>
                                        <mat-error  class="text-danger" *ngIf="f3.email.errors?.email && (f3.email?.dirty || f3.email?.touched || submitted || saleform3)">
                                            El E-Mail es Invalido
                                        </mat-error>
    
                                    </div>
                                    <div class="col-lg">
                                        <label class=" col-form-label font-bold">Teléfono</label>
                                        <input formControlName="celular" name ="selectedTelefono" type="text" class="form-control"  [ngClass]="{ 'is-invalid': f3.celular.errors && (f3.celular?.dirty || f3.celular?.touched || submitted || saleform3)}"/>
                                        <mat-error  class="text-danger" *ngIf="f3.celular.errors?.required && (f3.celular?.dirty || f3.celular?.touched || submitted || saleform3)">
                                            El Teléfono es Requerido
                                        </mat-error>
                                    </div>
                                </div>
                                <div>
                                    <br>
                                    <button matStepperPrevious class="btn btn-secondary btn-lg" type="button" (click)="sale3()">Anterior</button> 
                                    <button type="submit" class="btn btn-primary btn-lg" (click)="guardar()">Guardar</button>
                                </div>
                            </form>
                        </mat-step>
                        </mat-vertical-stepper>

                </div>
            </div>
        </div>
    </div>
</div>